<template>
    <div>
        <CustomTable :column-form="2" :tab="true">
            <template v-slot:btn-table>
                <CustomTab
                    :initialTab="active_tab"
                    :tabs="list_tab"
                    @tabChanged="handleTabChanged"
                />
            </template>
            <template v-slot:header>
                <!-- 1. Cán bộ quản lý -->
                <tr v-if="active_tab === 1">
                    <th rowspan="3">STT</th>
                    <th rowspan="3">Địa phương</th>
                    <th rowspan="3">Cán bộ quản lý</th>
                    <th colspan="7">Hiệu trưởng</th>
                    <th colspan="7">Phó Hiệu trưởng</th>
                </tr>
                <tr v-if="active_tab === 1">
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                </tr>
                <tr v-if="active_tab === 1">
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                </tr>

                <!-- 2. GV chuẩn Nghề nghiệp -->
                <tr v-if="active_tab === 2">
                    <th rowspan="4">STT</th>
                    <th rowspan="4">Địa phương</th>
                    <th rowspan="4">Tổng số GV</th>
                    <th colspan="21">
                        Giáo viên theo đánh giá chuẩn nghề nghiệp
                    </th>
                </tr>
                <tr v-if="active_tab === 2">
                    <th colspan="7">Tốt</th>
                    <th colspan="7">Khá</th>
                    <th colspan="7">Đạt</th>
                </tr>
                <tr v-if="active_tab === 2">
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                </tr>
                <tr v-if="active_tab === 2">
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                </tr>

                <!-- 3. GV biến động -->
                <tr v-if="active_tab === 3">
                    <th rowspan="3">STT</th>
                    <th rowspan="3">Địa phương</th>
                    <th colspan="7">Giáo viên nghỉ hưu trong năm học</th>
                    <th colspan="7">Giáo viên tuyển mới trong năm học</th>
                </tr>
                <tr v-if="active_tab === 3">
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                </tr>
                <tr v-if="active_tab === 3">
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                </tr>

                <!-- 4. Nhân viên -->
                <tr v-if="active_tab === 4">
                    <th rowspan="3">STT</th>
                    <th rowspan="3">Địa phương</th>
                    <th colspan="7">Nhân viên</th>
                </tr>
                <tr v-if="active_tab === 4">
                    <th rowspan="2">Tổng</th>
                    <th rowspan="2">Nữ</th>
                    <th rowspan="2">Dân tộc</th>
                    <th rowspan="2">Nữ DT</th>
                    <th colspan="2">Viên chức</th>
                    <th rowspan="2">Hợp đồng lao động</th>
                </tr>
                <tr v-if="active_tab === 4">
                    <th rowspan="1">HĐLV không xác định thời hạn</th>
                    <th rowspan="1">HĐLV xác định thời hạn</th>
                </tr>

                <!-- 5. GV bồi dưỡng  -->
                <tr v-if="active_tab === 5">
                    <th rowspan="2">STT</th>
                    <th rowspan="2">Địa phương</th>
                    <th colspan="4">
                        Giáo viên được bồi dưỡng thường xuyên (TT
                        26/2012/TT-BGDĐT)
                    </th>
                    <th colspan="4">
                        Giáo viên được tập huấn và tham gia giảng dạy về phòng,
                        chống HIV trên nền tảng Kỹ năng sống và GD sức khỏe sinh
                        sản
                    </th>
                    <th colspan="4">
                        Nhân viên được Tập huấn và tham gia giảng dạy về phòng,
                        chống HIV trên nền tảng Kỹ năng sống và GD sức khỏe sinh
                        sản
                    </th>
                </tr>
                <tr v-if="active_tab === 5">
                    <th rowspan="1">Tổng</th>
                    <th rowspan="1">Nữ</th>
                    <th rowspan="1">Dân tộc</th>
                    <th rowspan="1">Nữ DT</th>
                    <th rowspan="1">Tổng</th>
                    <th rowspan="1">Nữ</th>
                    <th rowspan="1">Dân tộc</th>
                    <th rowspan="1">Nữ DT</th>
                    <th rowspan="1">Tổng</th>
                    <th rowspan="1">Nữ</th>
                    <th rowspan="1">Dân tộc</th>
                    <th rowspan="1">Nữ DT</th>
                </tr>
            </template>
            <template v-slot:body>
                <template v-if="tableData.length === 0">
                    <tr>
                        <td colspan="10">Không có bản ghi nào.</td>
                    </tr>
                </template>
                <tr v-for="(item, index) in tableData" :key="index">
                    <td>
                        {{ (currentPage - 1) * limit + index + 1 }}
                    </td>
                    <td>12345678910JQK</td>
                    <td>55</td>
                    <td>55</td>
                </tr>
            </template>
            <template v-slot:pagi>
                <CustomPagination
                    v-show="total_rows > 0"
                    :tongbanghi="total_rows"
                    :pageSize="pageSize"
                    :pageStart="pageStart"
                    @pageChange="pageChange($event)"
                    @pageSizeChange="pageSizeChange($event)"
                >
                </CustomPagination>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import { getFromSessionStorage } from '@/utils/session'
import { hideLoading, showLoading } from '@/utils/loading'
import sendRequest from '@/services'
import Api from '@/constants/Api'
import { defaultToastConfig } from '@/utils'
import CustomTable from '@/components/CustomTable.vue'

import CustomPagination from '@/components/CustomPagination.vue'
import CustomTab from '@/components/CustomTab.vue'

export default {
    name: 'ReportPersonnel',
    components: {
        CustomTable,
        CustomPagination,
        CustomTab
    },
    data() {
        return {
            start: 0,
            total_rows: 0,
            currentPage: 1,
            limit: 25,
            pageSize: 25,
            pageStart: false,

            tableData: [],

            active_tab: 1,
            list_tab: [
                { number: 1, label: 'Cán bộ quản lý' },
                { number: 2, label: 'GV chuẩn Nghề nghiệp' },
                { number: 3, label: 'GV biến động' },
                { number: 4, label: 'Nhân viên' },
                { number: 5, label: 'GV bồi dưỡng' }
            ]
        }
    },

    methods: {
        handleTabChanged(tabNumber) {
            this.active_tab = tabNumber
        },
        async handleSearch() {
            showLoading()
            try {
                const request_data = {
                    namHoc: this.selectedYearFromStore,
                    capHocList: this.selectedGradeLevelFromStore,
                    hocKy: this.selectedSemesterFromStore,
                    limit: this.limit,
                    lstCapHoc: [],
                    maDonViList: this.unit_education,
                    maTruongHoc: '',
                    matruongHocList: [],

                    showOnlyIncompleteSchool: false,
                    start: this.start
                }

                const response = await sendRequest(
                    Api.ket_chuyen_du_lieu_len_bo.ket_chuyen_du_lieu.danh_sach,
                    request_data,
                    this.request_headers
                )

                if (response.rc == 0) {
                    hideLoading()
                } else if (response.rc == 2) {
                    hideLoading()

                    this.$toast.error(response.rd, defaultToastConfig)
                }
                this.total_rows = response.totalRows

                this.tableData = response.tableData.map((item) => {
                    return { ...item, isChecked: false }
                })
            } catch (error) {
                hideLoading()
            }
        }
    },
    mounted() {
        this.handleSearch()
    },

    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },

        selectedSemesterFromStore() {
            return this.$store.state.semester.semester
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped></style>
